import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Player } from 'ThreeTerminal_pc/video';

import { getiVideoData } from '../../../../../services/api';

import { classNames } from '@ifeng-fe/container_channel/common/client/utils/classnames';
import { formatImage } from '@ifeng-fe/public_method/src/utils/formatImage';

class VideoPlayer extends React.PureComponent {
    static propTypes = {
        data: PropTypes.object,
    };

    state = {
        videoConfig: '',
    };

    componentDidMount = () => {
        this.asyncGetVideo();
    };

    asyncGetVideo = async () => {
        const {
            data: { videoId },
        } = this.props;

        console.log('videoId', videoId);

        if (videoId) {
            try {
                const res = await getiVideoData(videoId);

                if (res && res.code === 0) {
                    this.setState({ videoConfig: res.data });
                } else {
                    alert(res.msg || '获取视频详情失败');
                }
            } catch (error) {
                alert(error.message);
            }
        }
    };

    render() {
        /**
         * 组件分发数据
         */
        const { data } = this.props;
        const { videoConfig } = this.state;

        const playermsg = {
            width: 668,
            height: 376,
            autoPlay: false,
            controls: true,
        };

        return (
            <div className={styles.videoPlayer}>
                <div className={styles.playerWrap}>
                    {videoConfig ? (
                        <Player videoConfig={videoConfig} playermsg={playermsg} />
                    ) : (
                        <div className={styles.image}>
                            <img src={data.image && formatImage(data.image, 668, 376)} alt="" />
                        </div>
                    )}
                </div>
                <div className={styles.title}>{data.title}</div>
            </div>
        );
    }
}

class VideoBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    state = {
        curIndex: 0,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { curIndex } = this.state;

        // console.log(content);

        return (
            <div className={styles.videoBox}>
                {content.map((item, index) => index === curIndex && <VideoPlayer data={item} key={index} />)}
                <div className={styles.dotWrap}>
                    <div className={styles.dot}>
                        {content.map((item, index) => (
                            <div
                                key={index}
                                className={classNames(styles.dotItem, index === curIndex ? styles.dotCur : '')}
                                style={{ marginRight: index === content.length - 1 ? 0 : 16 }}
                                onClick={() => this.setState({ curIndex: index })}
                            />
                        ))}
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(VideoBox);
